module.exports = __webpack_public_path__ + "649e7e763b5cacbbffba33e6d63f96da.svg";